// Module
var code = `<h1>GenAI</h1> <h3 class="metric-meaning">Что значит?</h3><p>Трафик из AI-ассистентов и чат-ботов, например ChatGPT, Perplexity, Gemini и т.д.</p> `;
// Exports
module.exports = code;